module.exports = __webpack_public_path__ + "img/necklace.c1716183.svg";